module.exports = __webpack_public_path__ + "static/media/qr-code.c952404e.png";